<template>
  <div class="login-wrapper">
    <loader :loading="loading" />
    <div class="d-flex flex-column flex-lg-row align-items-center mt-5 mt-lg-0">
      <div class="logo me-0 me-lg-5 mb-5 mb-lg-0">
        <h6 class="text-white mb-4">Painel de administração</h6>
        <img src="@/assets/logo-white.svg"/>
      </div>

      <div class="form ms-0 ms-lg-5" v-if="!success">
        <h2 class="title mb-1">Redefinir senha</h2>
        <p class="text-muted mb-4" style="font-size:14px">Informe o e-mail e a nova senha.</p>

        <div class="form-floating mb-3">
          <input
            ref="emailInput"
            type="email"
            class="form-control"
            :class="{ 'is-invalid': $v.email.$error }"
            v-model.trim="$v.email.$model"
            placeholder="Digite o Email"
            @keyup.enter="handleEmailEnter"
          >
          <label>Email</label>
          <div class="invalid-feedback">Informe um e-mail válido</div>
        </div>

        <div class="form-floating mb-3">
          <input
            ref="passwordInput"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': $v.password.$error }"
            v-model.trim="$v.password.$model"
            placeholder="Nova senha"
            @keyup.enter="handlePasswordEnter"
          >
          <label>Nova senha</label>
          <div class="invalid-feedback">Mínimo de 8 caracteres</div>
        </div>

        <div class="form-floating mb-3">
          <input
            ref="passwordConfirmInput"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': $v.password_confirmation.$error }"
            v-model.trim="$v.password_confirmation.$model"
            placeholder="Confirme a nova senha"
            @keyup.enter="submitForm"
          >
          <label>Confirme a nova senha</label>
          <div class="invalid-feedback">As senhas não coincidem</div>
        </div>

        <button class="btn btn-primary btn-block mt-3" @click.prevent="submitForm">Redefinir senha</button>
      </div>

      <div class="form ms-0 ms-lg-5 text-center" v-if="success">
        <h2 class="title mb-3">Senha redefinida!</h2>
        <p class="text-muted mb-4" style="font-size:14px">Sua senha foi alterada com sucesso.</p>
        <button class="btn btn-primary btn-block" @click.prevent="$router.push({ name: 'login' })">Ir para o login</button>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from "@/components/shared/loader.vue";
import axios from "axios";
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";

export default {
  name: 'reset-password',
  components: { Loader },
  data() {
    return {
      loading: false,
      success: false,
      email: '',
      password: '',
      password_confirmation: '',
    }
  },
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8) },
    password_confirmation: { required, sameAsPassword: sameAs('password') }
  },
  mounted() {
    this.$nextTick(() => this.$refs.emailInput.focus());
  },
  methods: {
    handleEmailEnter() {
      if (this.password) {
        this.submitForm();
      } else {
        this.$refs.passwordInput.focus();
      }
    },
    handlePasswordEnter() {
      if (this.password_confirmation) {
        this.submitForm();
      } else {
        this.$refs.passwordConfirmInput.focus();
      }
    },
    async submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;

      await axios.post('/admin/auth/reset-password', {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.$route.query.token
      }).then(() => {
        this.success = true;
      }).catch(() => {
        this.$swal.fire({
          icon: 'error',
          html: 'Não foi possível redefinir a senha. O link pode ter expirado.',
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  height: calc((var(--vh, 1vh) * 100));
  width: 100vw;
  background: var(--primary);
  padding: 1rem;

  @media (min-width: 992px) {
    align-items: center;
  }
}
.logo {
  img {
    width: 220px;

    @media (min-width: 992px) {
      width: 300px;
    }
  }
}
.form {
  background: var(--white);
  border-radius: .32rem;
  padding: 2rem;
  width: 90vw;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, .2);

  @media (min-width: 992px) {
    max-width: 360px;
  }

  .btn {
    height: 55px;
    margin-bottom: 0.5rem !important;
    font-weight: 700 !important;
    font-size: 1rem;
  }
}
.title {
  font-size: 22px;
  font-weight: 700;
}
</style>
